import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {TimestampsService} from '../timestamps.service';
import {TradingInstrumentDisplayNameService} from '../trading-instruments/trading-instrument-display-name.service';
import {ActionItemWireDto} from '../shell-communication/action-board-operations';
import {ActionItemView, describeItem} from './action-item-view';

/**
 * CR-20260922-001 — one card row (§5.6 "Cards"): source chip, headline, overdue badge, origination
 * time. Whole card in the severity colour while live; grey when completed with text tags of its
 * severity and completion state. Clicking it selects it; the detail opens in the reading pane on the
 * right (owner 2026-09-22 — no downward expansion). Nothing on a card dismisses it.
 */
@Component({
    selector: 'ets-action-board-card',
    templateUrl: './action-board-card.component.html',
    styleUrls: ['./action-board-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActionBoardCardComponent implements OnChanges {

    constructor(
        private readonly _timestamps: TimestampsService,
        private readonly _displayNames: TradingInstrumentDisplayNameService
    ) {
    }

    @Input() item: ActionItemWireDto;
    @Input() todayDayKey: string;
    @Input() selected: boolean;
    /** Unread styling applies only on the recipient's own board — a manager's view shows no unread state. */
    @Input() isOwnBoard: boolean;
    /** The hover action that puts the item back to unread (own board only). */
    @Input() canMarkUnread: boolean;
    /** CR-20260929-002: the owner's short name, the first chip — set in the All view only. */
    @Input() ownerName: string | null = null;

    @Output() select = new EventEmitter<ActionItemWireDto>();
    @Output() markUnread = new EventEmitter<ActionItemWireDto>();

    /** Gmail rule: unread = the recipient has not expanded it yet. Completed items are never "unread". */
    /** The RECIPIENT's read state, shown on any board (owner 2026-09-23: a manager viewing a
     * subordinate sees what the subordinate has not read yet). Writing it stays the recipient's. */
    get isUnread(): boolean {
        return !!this.item && !this.item.readAtUtc && !this.item.completedAtUtc;
    }

    onMarkUnread(ev: Event): void {
        ev.stopPropagation();
        this.markUnread.emit(this.item);
    }

    view: ActionItemView;

    ngOnChanges(): void {
        if (this.item) {
            this.view = describeItem(this.item, this.todayDayKey, this._timestamps.getDefaultTimezone() || null,
                t => this._displayNames.getOptionDisplayName(t));
        }
    }

    onClick(): void {
        this.select.emit(this.item);
    }
}
